/*
 * Copyright (c) CIRROM 2026.
 */

/**
 * Placeholder the server is expected to swap for a freshly generated value on every
 * response. Until that substitution exists it stays in the markup verbatim, and a
 * literal placeholder is worse than no nonce at all: it would be a constant, which any
 * injected style could simply copy. Treat it as absent.
 */
const NONCE_PLACEHOLDER = "__CSP_NONCE__";

/**
 * The per-request CSP nonce, read once from the document.
 *
 * Both style injectors in this app take a nonce — emotion (via the cache MUI renders
 * through) and AG Grid (via its styleNonce grid option) — which is what a
 * `style-src 'nonce-...'` policy needs instead of the far weaker 'unsafe-inline'.
 * Returns undefined when nothing has been substituted in, and both libraries then
 * behave exactly as they do today, so this is safe to ship before the server side lands.
 */
export const getCspNonce = (): string | undefined => {
  if (typeof document === "undefined") {
    return undefined;
  }

  const content = document
    .querySelector('meta[name="csp-nonce"]')
    ?.getAttribute("content");

  if (!content || content === NONCE_PLACEHOLDER) {
    return undefined;
  }

  return content;
};
